<template>
    <b-row class="my-4" align-h="center">
        <b-col cols="auto">
            <b-button-group size="lg">
                <b-button class="shadow-none" id="off-button" variant="primary" :pressed="operation == OPERATION.OFF" @click="operationPressed">
                    Off
                </b-button>
                <b-button class="shadow-none" id="on-button" variant="primary" :pressed="operation == OPERATION.ON" @click="operationPressed">
                    On
                </b-button>
                <b-button class="shadow-none" id="schedule-button" variant="primary" :pressed="operation == OPERATION.SCHEDULE"
                          @click="operationPressed">
                    Schedule
                </b-button>
            </b-button-group>
        </b-col>
    </b-row>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: "OffOnScheduleButton",

        props: [
            'value'
        ],

        data() {
            return {}
        },

        computed: {
            ...mapGetters({
                getParameters: 'virtualDevice/parameters',
            }),

            parameters() {
                return this.getParameters(this.$route.params.id);
            },

            operation: {
                get: function () {
                    return this.value;
                },

                set: function (value) {
                    this.$emit('update:value', value);
                }
            },

            OPERATION() {
                return {
                    OFF: 0,
                    ON: 1,
                    SCHEDULE: 2
                }
            }
        },

        methods: {
            operationPressed(event) {
                let buttonId = event.target.id;

                if (buttonId === 'off-button') {
                    this.operation = this.OPERATION.OFF;
                } else if (buttonId === 'on-button') {
                    this.operation = this.OPERATION.ON;
                } else if (buttonId === 'schedule-button') {
                    this.operation = this.OPERATION.SCHEDULE;
                }
            }
        }
    }
</script>

<style scoped>
</style>